const securityConditionOptions = [
  {
    "key": "NO_SECURITY_CONCERN",
    "text": "No security concern"
  },
  {
    "key": "SUSPECTED_FRAUD",
    "text": "Suspected fraud"
  },
  {
    "key": "IDENTIFICATION_VERIFIED",
    "text": "Identification verified"
  },
  {
    "key": "ELECTRONIC_TRANSACTION_WITH_DIGITAL_SIGNATURE",
    "text": "Electronic transaction with digital signature"
  },
  {
    "key": "NONSECURE_ELECTRONIC_TRANSACTION",
    "text": "Nonsecure electronic transaction"
  },
  {
    "key": "SECURE_ELECTRONIC_TRANSACTION_WITH_CARDHOLDER_CERTIFICATE",
    "text": "Secure electronic transaction with cardholder certificate"
  },
  {
    "key": "SECURE_ELECTRONIC_TRANSACTION_WITHOUT_CARDHOLDER_CERTIFICATE",
    "text": "Secure electronic transaction without cardholder certificate"
  },
  {
    "key": "CHANNEL_ENCRYPTED_ELECTRONIC_TRANSACTION",
    "text": "Channel encrypted electronic transaction"
  },
  {
    "key": "CVV_VALID",
    "text": "CVV valid"
  },
  {
    "key": "CVV_INVALID",
    "text": "CVV invalid"
  },
  {
    "key": "INTERNET_PINNED_DEBIT_TRANSACTION",
    "text": "Internet pinned debit transaction"
  }
]

export default securityConditionOptions;